<template>
  <div>
    <ul class="top-info">
      <li class="text">
        <p class="title">MEMBERSHIP</p>
        <p>전남드래곤즈 회원정보 수정입니다.</p>
      </li>
    </ul>

    <div class="my-info join-form">
      <ul class="input-div">
        <li class="title">아이디</li>
        <li>
          <input type="text" class="input-style" v-model="formData.id" disabled>
        </li>
      </ul>
      <ul class="input-div">
        <li class="title">비밀번호 변경</li>
        <li>
          <input type="password" class="input-style" v-model="formData.pw" @keyup="inputCheck('pwd')" placeholder="비밀번호를 입력하세요">
        </li>
        <li class="msg-li">
          <p>비밀번호는 영어, 숫자, 특수문자 조합으로 9~16자리 가능합니다.</p>
          <p v-if="!isEmpty(pwdCondCheckErr)" :class="{err: !pwdCondCheckErr}">
            {{!pwdCondCheckErr ? '위 조건에 맞게 다시 입력해주세요.' : ''}}
          </p>
        </li>
      </ul>
      <ul class="input-div">
          <li class="title">비밀번호 변경 확인</li>
        <li>
          <input type="password" class="input-style" v-model="formData.repw" @keyup="inputCheck('pwd')" placeholder="비밀번호를 재 입력하세요">
        </li>
        <li class="msg-li">
          <p v-if="!isEmpty(pwdCheckErr)" :class="{check: !pwdCheckErr, err: pwdCheckErr}">
            {{pwdCheckErr ? '비밀번호가 불일치합니다. 다시 입력해주세요' : '비밀번호가 일치합니다.'}}
          </p>
        </li>
      </ul>
      <ul class="input-div">
        <li class="title">성명</li>
        <li>
          <input type="text" class="input-style" v-model="formData.name" disabled>
        </li>
      </ul>
      <ul class="input-div">
        <li class="title">생년월일</li>
        <li>
          <input type="text" class="input-style" v-model="formData.birth" disabled>
        </li>
      </ul>
      <ul v-if="!isEmpty(formData.gender)" class="input-div">
        <li class="title">성별</li>
        <li>
          <input type="text" class="input-style" v-model="formData.gender" disabled>
        </li>
      </ul>
      <ul class="input-div">
        <li class="title">휴대폰번호</li>
        <li class="id-li" v-if="formData.authType === 'phone'">
          <input type="text" class="input-style" v-model="formData.phone" disabled>
          <button class="id-check" @click="cert(formData.authType)">번호변경</button>
        </li>
        <!-- 아이핀 인증일 경우 -->
        <li v-if="formData.authType === 'ipin'" class="id-li pt">
          <!--<input type="text" class="input-style" v-model="formData.phone">-->
          <InputPhone v-model="formData.phone" :value="formData.phone" @inputNum="inputCheck('phone')" />
          <button class="id-check" @click="sendCode">인증코드 요청</button>
        </li>
        <li v-if="formData.authType === 'ipin'" class="id-li pt">
          <input type="text" class="input-style" v-model="formData.authCode" placeholder="인증코드를 입력하세요.">
          <button class="id-check" @click="sendCodeCheck">인증코드 확인</button>
        </li>
      </ul>
      <ul class="input-div">
        <li class="title">이메일 주소</li>
        <li class="id-li">
          <input type="text" class="input-style" v-model="formData.email" @keyup="inputCheck('email')" placeholder="이메일 주소를 입력하세요">
          <button class="id-check" @click="emailCheckFunc">중복확인</button>
        </li>
        <li class="msg-li">
          <p v-if="!isEmpty(emailCheckErr)" :class="{check: !emailCheckErr, err: emailCheckErr}">
            {{emailCheckErr ? '사용할 수 없는 이메일입니다.' : '사용 가능한 이메일입니다.'}}
          </p>
        </li>
      </ul>
      <ul class="input-div">
        <li class="title">광고성 정보 수신 동의 안내</li>
        <li>
          <div class="text-area">
<pre>
회사는 다음과 같이 귀하의 개인정보를 수집 및 이용 합니다.

1. 개인정보의 수집 및 이용 목적
- 구단 소식 및 경기 정보 안내, 이벤트, 홍보, 프로모션 정보 등 전자적 전송매체를 이용한 광고성 정보 전송

2. 수집하는 개인정보의 항목
- 아이디, 회원명, 핸드폰번호

3. 개인정보의 보유 및 이용기간
- 수신 거부 혹은 회원 탈퇴시까지

4. 동의를 거부할 권 리 및 동의 거부시 불이익 사항
귀하는 본 개인정보의 수집 및 이용에 대한 동의를 거부할 권리가 있으며, 동의를 거부하더라도 별도의 불이익 사항은 없습니다.
</pre>
          </div>
        </li>
        <li class="info-agree">
          <input type="radio" name="allAgree" v-model="formData.adPush" value="Y" class="select-style">
          <label class="radio-label pr">동의</label>
          <input type="radio" name="allAgree" v-model="formData.adPush" value="N" class="select-style">
          <label class="radio-label">미동의</label>
        </li>
      </ul>
      <div class="btn-div">
        <button class="login-btn" @click="myInfoFunc">정보수정</button>
        <button class="retry-btn" @click="retry">다시입력</button>
      </div>
    </div>

  </div>
</template>

<script>
import {isEmail, isEmpty, allTrim, trim, telHyphen, expPhone, onlyNumber, isPwd} from '@/lib';
import InputPhone from "@/components/Common/InputPhone.vue";
import dayjs from "dayjs";

export default {
  name: 'MyInfo',
  components: {InputPhone},
  data() {
    return {
      formData: {
        adPush: null
      },
      pwdCondCheckErr: null,
      pwdCheckErr: null,
      emailCheck: true,
      emailCheckErr: null,
      authCodeStatus: true, // 아이핀인증 인증코드 확인 여부
      loading: false,
    }
  },
  created () {
    this.getUserInfo();
  },
  methods: {
    isEmpty,
    async getUserInfo() {
      const {data} = await this.$http.get('/user/detail')
      if(data.success) {
        const userInfo = data.data.user;
        this.formData.id = userInfo.user_id;
        this.formData.name = userInfo.name;
        this.formData.birth = dayjs(userInfo.birth).format('YYYY-MM-DD');
        this.formData.phone = telHyphen(userInfo.mobileno);
        this.formData.email = userInfo.email;
        this.formData.adPush = userInfo.agree_sms;
        this.formData.gender = !isEmpty(userInfo.gender) ? userInfo.gender === 0 ? '여자' : '남자' : userInfo.gender;
        this.formData.authType = userInfo.ipin_chk;
        // this.formData.authType = userInfo.ipin_chk;
      }
    },
    emailCheckFunc() {
      if(isEmpty(allTrim(this.formData.email))) {
        alert('이메일을 입력하세요.');
        return false;
      }
      if(!isEmail(this.formData.email)) {
        alert('이메일 형식에 맞게 입력하세요.');
        return false;
      }

      this.emailCheck =  true;
      this.emailCheckErr = false;
    },
    inputCheck(type) {
      if(type.includes('email')) {
        this.emailCheck = false;
        this.emailCheckErr = null;
      }
      if(type.includes('phone')) {
        this.authCodeStatus = false;
      }
      if(type.includes('pwd')) {
        this.pwdCondCheckErr = isPwd(this.formData.pw);

        if(this.formData.pw !== this.formData.repw) {
          this.pwdCheckErr = true;
        }else {
          this.pwdCheckErr = false;
        }
      }
    },
    async sendCode() {
      if(this.loading || this.authCodeStatus) {
        return false;
      }

      if(!expPhone(onlyNumber(this.formData.phone))) {
        alert('휴대폰 번호를 확인해주세요.');
        return false;
      }

      this.loading = true;
      const {data} = await this.$http.post('/auth/sms/request',
          {mobileno: onlyNumber(this.formData.phone)});
      // console.log('인증코드 발송 res ==========>', data);
      if(data.success) {
        alert('인증코드가 발송되었습니다.');
      } else {
        alert('잠시 후 다시 시도해주세요.');
      }
      this.loading = false;
    },
    async sendCodeCheck() {
      if(this.loading) {
        return false;
      }
      if(isEmpty(this.formData.authCode)) {
        alert('인증코드를 입력하세요.');
        return false;
      }

      this.loading = true;
      const {data} = await this.$http.post('/auth/sms/check',
          {
            mobileno: onlyNumber(this.formData.phone),
            authCode: this.formData.authCode
          });
      // console.log('인증코드 확인 res ==========>', data);
      if(data.success) {
        alert('인증코드가 확인되었습니다.');
        this.authCodeStatus = true;
      } else {
        alert('인증코드가 일치하지 않습니다.');
        this.formData.authCode = '';
        this.authCodeStatus = false;
      }
      this.loading = false;
    },
    async myInfoFunc() {
      if(this.loading) {
        return false;
      }
      if(!this.validityCheck()) {
        return false;
      }

      if(confirm('정보수정 하시겠습니까?')) {
        this.loading = true;
        // console.log('최종 >>>> ', this.formData);
        const obj = {
          mobileno: onlyNumber(this.formData.phone),
          email: this.formData.email,
          agree_sms: this.formData.adPush,
        }
        if(this.formData.pw) {
          obj.user_pw = this.formData.pw;
          obj.re_password = this.formData.repw;
        }

        const {data} = await this.$http.post('/user/update', obj);
        // console.log('정보수정 ok >>>> ', data);
        if(data.success) {
          alert('정보수정이 완료되었습니다.');
          this.$router.push({name: 'myPageView'});
        } else {
          alert(data.message);
        }
        this.loading = false;
      }
    },
    validityCheck() {
      if(!isEmpty(allTrim(this.formData.pw)) && isEmpty(allTrim(this.formData.repw))) {
        alert('비빌번호를 입력하세요.');
        return false;
      }
      if(!isEmpty(this.formData.pw) && !isEmpty(this.formData.repw)) {
        if(this.formData.pw !== this.formData.repw) {
          alert('비빌번호가 일치하지 않습니다.');
          return false;
        }
      }
      if(!this.authCodeStatus){
        alert('휴대폰 인증을 해주세요.');
        return false;
      }
      if(isEmpty(this.formData.email)) {
        alert('이메일을 입력하세요.');
        return false;
      }
      if(!isEmpty(this.formData.email) && !this.emailCheck) {
        alert('이메일 중복확인 하세요.');
        return false;
      }
      if(this.formData.adPush !== 'Y' && this.formData.adPush !== 'N') {
        alert('광고성 정보 수신 동의를 선택하세요.');
        return false;
      }

      return true;
    },
    retry() {
      if(!confirm('다시 입력하시겠습니까?')) {
        return false;
      }

      // 입력 정보
      this.formData.pw = '';
      this.formData.repw = '';
      this.formData.email = '';
      this.formData.adPush = null;

      this.pwdCondCheckErr = null;
      this.pwdCheckErr = null;
      this.emailCheck = false;
      this.emailCheckErr = null;
    },
    cert(type) {
      const apiUrl = process.env.VUE_APP_API_URL;
      let popup;
      if(type === 'phone') {
        const url = `${apiUrl}/auth/kcb/request?redirectType=myInfo`
        popup = window.open(url, 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');

        window.onmessage = (e) => {
          if(e.origin === `${apiUrl}`) {
            const data = JSON.parse(e.data.replace(/&#34;/gm, '"'));
            // console.log('phone Data= ===========>' , data);
            if(data.err === 'true') {
              return alert('본인인증에 실패하였습니다.');
            } else {
              if(data.exit === 'true') {
                return alert('이미 가입된 휴대폰 번호입니다.');
              }
              this.formData.phone = data.mobileno;
              this.formData.di = data.di;
            }
          }
        }
      }
    }
  }
}
</script>
